angular.module("rightPaneModule")
    .directive("dblEngagementActivity", ['$modal', function($modal) {
        return {
            restrict: "E",
            templateUrl: '/resources/right-pane/components/engagement/dbl-engagement-activity.directive.html',
            scope: {
                activities: '=',
                awardTo: '='
            },
            link: function(scope, element) {

                scope.isCertificate = function(activity) {
                    return activity.event_code === 200;
                };

                scope.openEngagementActivityModal = function (activity) {
                    var modal = $modal.open({
                        templateUrl: 'resources/core/partials/engagement-certificate-modal.html',
                        windowClass: 'engagement-certificate-modal',
                        controller: 'EngagementCertificateModalController',
                        resolve: {
                            dblActivity: function () {
                                return activity;
                            },
                            studentName: function () {
                                return scope.awardTo;
                            }
                        }
                    });
                };
            }
        };
    }]);
